import request from './index'

// 用户登录
export function login (data) {
  // 将JSON数据转换为URLSearchParams格式，用于OAuth2PasswordRequestForm
  const formData = new URLSearchParams()
  formData.append('username', data.username)
  formData.append('password', data.password)

  return request({
    url: '/api/auth/login',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取用户信息
export function getUserInfo () {
  return request({
    url: '/api/auth/me',
    method: 'get'
  })
}

// 用户登出
export function logout () {
  return request({
    url: '/api/auth/logout',
    method: 'post'
  })
}

// 刷新token
export function refreshToken (refreshToken) {
  return request({
    url: '/api/auth/refresh',
    method: 'post',
    data: { refresh_token: refreshToken }
  })
}

// 更新用户信息
export function updateUserInfo (data) {
  // 从用户信息中获取ID，或者让调用者提供ID
  // 这里假设data中包含id字段，或者使用当前登录用户的ID
  const userId = data.id || (JSON.parse(localStorage.getItem('userInfo') || '{}').id)
  return request({
    url: `/api/users/${userId}`,
    method: 'put',
    data
  })
}

// 修改密码
export function changePassword (data) {
  return request({
    url: '/api/users/change-password',
    method: 'post',
    data
  })
}

// 获取用户列表
export function getUserList (params) {
  return request({
    url: '/api/users',
    method: 'get',
    params
  })
}

// 创建用户
export function createUser (data) {
  return request({
    url: '/api/users',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser (id, data) {
  return request({
    url: `/api/users/${id}`,
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser (id) {
  return request({
    url: `/api/users/${id}`,
    method: 'delete'
  })
}

// 重置用户密码
export function resetUserPassword (id) {
  return request({
    url: `/api/users/${id}/reset-password`,
    method: 'post'
  })
}

// 默认导出所有API函数
export default {
  login,
  getUserInfo,
  logout,
  refreshToken,
  updateUserInfo,
  changePassword,
  getUserList,
  createUser,
  updateUser,
  deleteUser,
  resetUserPassword
}
